function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 0C3.136 0 0 3.136 0 7s3.136 7 7 7 7-3.136 7-7-3.136-7-7-7zm0 13.146C3.626 13.146.882 10.374.882 7S3.626.868 7 .868 13.132 3.626 13.132 7c0 3.374-2.758 6.146-6.132 6.146zm-.937-1.771H7.74V9.74H6.063v1.635zM8.925 3.26c-.468-.421-1.121-.635-1.94-.635-.729 0-1.356.2-1.87.597-.569.459-.753 1.296-.74 1.911v.23h1.586v-.23c0-.367.126-.777.27-.89.2-.144.453-.218.754-.218.346 0 .594.079.77.236.169.175.254.43.254.754 0 .3-.064.53-.206.731-.135.208-.385.522-.766.968-.444.396-.683.668-.802.916-.107.24-.157.623-.157 1.207v.23h1.616v-.23c0-.333.031-.57.053-.69.038-.138.203-.321.312-.436a7.34 7.34 0 0 0 1.133-1.263c.287-.433.433-.92.433-1.447 0-.755-.237-1.342-.7-1.741z",
  id: "tooltip-icon"
});

var SvgQuestionmark = function SvgQuestionmark(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    width: "1rem",
    height: "1rem",
    fill: "currentColor",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestionmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/questionmark.585a620d.svg";
export { ForwardRef as ReactComponent };